<script>
import axios from "axios";
import Swal from "sweetalert2";
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import {
  authFackMethods
} from "@/state/helpers";

import {
  required
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Buildings",
    meta: [
      {
        name: "Buildings",
      },
    ],
  },
  components: { Layout, PageHeader },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      preservePage: 1,
      pageLimit:50,
      modalTitle:'',
      status: [{ value:'active',text:'Active'},{value:'inactive',text:'InActive'}],
      locations: {},
      buildings: {},
      buildingId:'',
      searchBy:'',
      buildingForm: {
        name: "",
        description: "",
        location_id: null,
      },
      searchForm: {
        name: "",
        location: null,
      },
      typesubmit: false,
      isUpdate: false,
      isAdd: false,
      isName: false,
      isLocation: false,
      isSearching: false,
      isLoading:false,
      noRecord: false,
    }
  },
  validations: {
    buildingForm: {
      name: { required },
      description: { required },
      location_id: { required }
    },
  },
  mounted(){
    this.getBuildings();
  },
  methods: {

    getBuildings(page){
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === 'undefined'){
        page = 1
      }
      this.preservePage = page;
      let filter = '&per_page='+ this.pageLimit
      if (this.searchForm.name){
        filter += '&name='+ this.searchForm.name
      }
      if (this.searchForm.location){
        filter += '&location='+ this.searchForm.location
      }
      axios.get('admin/buildings?pagination=true&page='+ page + filter).then(res =>{
        this.buildings = res.data.response;
        this.isLoading = false;
        if (!this.buildings.data.length){
          this.noRecord = true;
          if (page > 1){
            this.getBuildings(page-1);
          }
        }
      }).catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            this.logout();
          }
        }
      })
    },
    ...authFackMethods,

    getLocations(){
      axios.get('admin/locations').then(res =>{
        this.locations = res.data.response;
      })
    },

    showAddModal() {
      this.typesubmit = false;
      this.modalTitle = 'Add Building'
      this.$bvModal.show('buildingModal');
      this.isAdd = true;
      this.isUpdate = false;
      this.getLocations();
      this.buildingForm = {
        name: "",
        description: "",
        location_id: null,
      };
    },

    showEditModal(building) {
      this.typesubmit = false;
      this.getLocations();
      this.modalTitle = 'Edit Building'
      this.$bvModal.show('buildingModal');
      this.buildingForm.name = building.name;
      this.buildingForm.description = building.description;
      this.buildingForm.location_id = building.location_id;
      this.buildingId = building.id;
      this.isUpdate = true;
      this.isAdd = false;
    },

    deleteBuilding(building) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        showLoaderOnConfirm: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.isConfirmed) {
          var token = localStorage.getItem('token');
          var config = {
            headers: {
              Authorization: 'Bearer ' + token,
              'Accept': 'application/json'
            }
          };
          if (token) {
            axios.delete('admin/buildings/'+building.id, config)
                .then((res) => {
                  if (res.status == '200'){
                    Swal.fire({
                      title: "Deleted!",
                      text: building.name + " has been deleted!",
                      icon: "success",
                      width: 350,
                      showConfirmButton: false,
                      timer: 1500
                    });
                    this.getBuildings(this.preservePage);
                  }
                })
                .catch((err) => {
                  if (err.response) {
                    Swal.fire({
                      title: "Error!",
                      text: err.response.data.error.message,
                      icon: "danger",
                      width: 350,
                      showConfirmButton: true
                    });
                  }
                })
          }
        }
      });
    },

    updateBuildingForm() {
      this.typesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.patch('admin/buildings/'+this.buildingId, this.buildingForm, config)
              .then((res) => {
                if (res.status == '200'){
                Swal.fire({
                  title: "Good job!",
                  text:"Building updated successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.getBuildings();
                this.$bvModal.hide('buildingModal');
                this.buildingForm = {
                  name: "",
                  description: "",
                  location_id: null,
                };
                this.typesubmit = false;
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
        }
      }

    },

    addBuildingForm() {
      this.typesubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.post('admin/buildings', this.buildingForm, config)
              .then((res) => {
                if (res.status == '200'){
                  Swal.fire({
                    title: "Good job!",
                    text:"Building added successfully!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.getBuildings();
                  this.$bvModal.hide('buildingModal');
                  this.buildingForm = {
                    name: "",
                    description: "",
                    location_id: null,
                  };
                  this.typesubmit = false;
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
        }
      }

    },

    searchOption(event){
      this.searchForm = {
            name: "",
            location: null,
      };
      let selectedValue = event.target.value
      if (selectedValue == ''){
        this.resetSearch();
      }
      if (selectedValue == 'name') {
        this.isName = true;
        this.isLocation = false;
        this.isSearching = true;
      }
      if (selectedValue == 'location') {
        this.isName = false;
        this.isLocation = true;
        this.isSearching = true;
      }
      if (selectedValue == 'status') {
        this.isName = false;
        this.isLocation = false;
        this.isSearching = true;
      }
    },

    searchDepartment(){
      this.getBuildings();
    },

    resetSearch(){
      this.searchForm = {
        name: "",
        location: null,
      };
      this.isSearching = false;
      this.isName = false;
      this.isLocation = false;
      this.searchBy ='';
      this.getBuildings();
    }

  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">

        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Buildings</h5>
          </div>

          <div class="mb-4 mdl-btns ms-auto">

            <!--Add Department-->
            <b-button id="show-btn" @click="showAddModal" variant="primary" title="Add">
              Add Building
            </b-button>

          </div>

        </div>

        <form class="row align-items-center form-inline mb-4 border p-3 m-0">
          <div class="col-md-12">
            <h4 class="font-size-14">Search By:</h4>
          </div>
          <div class="col-md-4">
            <select
                class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
              <option value="">Select Option</option>
              <option value="name">Name</option>
              <option value="location">Location</option>
            </select>
          </div>
          <div class="col-md-2 sm-hidden xs-hidden"></div>
          <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">

              <div class="col-md-12 d-flex">
                <input v-if="isName"
                  v-model="searchForm.name"
                  type="text"
                  class="ps-4 form-control"
                  placeholder="Type Building Name"
              />
                <input v-if="isLocation"
                    v-model="searchForm.location"
                    type="text"
                    class="ps-4 form-control"
                    placeholder="Type Location"
                />

                <b-button v-if="isSearching" id="show-btn" class="btn-find" @click="searchDepartment" variant="primary" title="Search">
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                <b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                          variant="primary" title="Reset">
                  <i class="bx bx-reset"> Reset</i>
                </b-button>
              </div>
          </div>
          </div>
        </form>


        <div class="table-responsive ">
          <table class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0">

            <thead class="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Location</th>
              <th scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="noRecord">
              <td colspan="5" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </td>
            </tr>
            <tr v-if="isLoading">
              <td colspan="5" class="text-center p-0">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </td>
            </tr>

            <tr v-else v-for="(building, index) in buildings.data" :key="index">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{building.name}}
                </h5>
              </td>
              <td>
                <p v-if="building.description" class="text-muted mb-0 text-wrap ">
                  {{building.description.substr(0, 50) + '...'}}
                </p>
                <p v-if="!building.description" class="text-muted mb-0 text-wrap ">
                  N/A
                </p>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap">
                  {{building.location_name ? building.location_name : '-'}}
                </p>
              </td>
              <td class="text-center">
                <b-button id="show-btn" @click="showEditModal(building)" variant="primary" title="Edit">
                  <i class="bx bx-pencil"></i>
                </b-button>
                <b-button @click="deleteBuilding(building)" class="ms-2" variant="danger" title="Delete">
                  <i class="bx bx-trash"></i>
                </b-button>
              </td>

            </tr>

            </tbody>
          </table>
        </div>

        <pagination class="mt-4" :data="buildings" :limit="10" @pagination-change-page="getBuildings"></pagination>

      </div>
    </div>

    <b-modal
        id="buildingModal"
        centered
        :title="modalTitle"
        title-class="font-18"
        hide-footer
    >
      <form>

        <div class="mb-3">
          <label>Building Name</label>
          <input
              v-model="buildingForm.name"
              type="text"
              class="form-control"
              placeholder="Enter Building Name"
              name="name"
              :class="{
                    'is-invalid': typesubmit && $v.buildingForm.name.$error,
                  }"
          />
          <div
              v-if="typesubmit && $v.buildingForm.name.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.buildingForm.name.required"
                  >Building name is required.</span
                  >
          </div>
        </div>

        <div class="mb-3">
          <label>Description</label>
          <div>
                  <textarea
                      v-model="buildingForm.description"
                      class="form-control"
                      name="description"
                      :class="{
                      'is-invalid': typesubmit && $v.buildingForm.description.$error,
                    }"
                      rows="5" placeholder="Enter Description"
                  ></textarea>
            <div
                v-if="typesubmit && $v.buildingForm.description.$error"
                class="invalid-feedback"
            >
                    <span v-if="!$v.buildingForm.description.required"
                    >Description is required.</span
                    >
            </div>
          </div>
        </div>

        <div class="mb-3">

          <label class="mt-0">Select Location</label>

          <b-form-select class="form-select" v-model="buildingForm.location_id" :options="locations"
                         value-field="id"
                         text-field="name"
                         :class="{'is-invalid': typesubmit && $v.buildingForm.location_id.$error,}"
          >
            <option slot="first" :value="null" disabled>Select Location</option>
          </b-form-select>
          <div
              v-if="typesubmit && $v.buildingForm.location_id.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.buildingForm.location_id.required"
                  >Location is required.</span>
          </div>

        </div>

        <div class="mb-0">
          <div>
            <button type="button" v-if="isAdd" @click="addBuildingForm" class="btn btn-primary">Add Building</button>
            <button type="button" v-if="isUpdate" @click="updateBuildingForm" class="btn btn-primary">Update Building</button>
          </div>
        </div>

      </form>
    </b-modal>

  </Layout>
</template>
<style scoped>
.mdl-btns button:nth-child(1){
  margin-right:1rem;
}
.app-search input, .app-search select{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
}
.app-search .btn-find{
  width: 40%;
  border-top-right-radius:30px;
  border-bottom-right-radius:30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow:none;
}
.app-search .btn-reset{
  width: 40%;
  font-size: 15px;
  box-shadow:none;
  border-radius:30px;
}
</style>
